import { Container } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Seo from "../../components/Seo/Seo";
import site, { getService } from "../../data/site";
import { requestBookCall } from "../../lib/bookCall";
import { serviceSchema } from "../../seo/schema";
import NotFoundPage from "../NotFound/NotFoundPage";
import classes from "./Services.module.css";

export default function ServicePage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = getService(slug);

  if (!service) {
    return <NotFoundPage />;
  }

  const others = site.services.filter((item) => item.slug !== service.slug);

  return (
    <main className="page">
      <Seo
        title={service.seoTitle}
        description={service.seoDescription}
        path={`/services/${service.slug}`}
        jsonLd={serviceSchema(service)}
      />
      <article className={classes.page}>
        <Container>
          <nav className={classes.crumbs} aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">/</span>
            <Link to="/services">Services</Link>
            <span aria-hidden="true">/</span>
            <span>{service.title}</span>
          </nav>
          <div className={classes.layout}>
            <div className={classes.media}>
              <img
                src={service.image}
                alt={service.imageAlt}
                width={service.width}
                height={service.height}
                decoding="async"
              />
            </div>
            <div>
              <div className="sectionEyebrow">Services</div>
              <h1 className="sectionTitle">{service.title}</h1>
              <p className={classes.hook}>{service.hook}</p>
              <p className={classes.overview}>{service.overview}</p>
              <p className={classes.label}>What you get</p>
              <ul className={classes.deliverables}>
                {service.deliverables.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <p className={classes.bestFor}>
                <span>Best for</span> {service.bestFor}
              </p>
              <div className={classes.actions}>
                <button
                  type="button"
                  className="buttonHome"
                  onClick={() => requestBookCall(navigate)}
                >
                  Book a Call
                </button>
                <Link className="buttonHomeOutline" to="/services">
                  All services
                </Link>
              </div>
            </div>
          </div>
          <aside className={classes.others} aria-label="Other services">
            <h2>Other services</h2>
            <ul>
              {others.map((item) => (
                <li key={item.slug}>
                  <Link to={`/services/${item.slug}`}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </aside>
        </Container>
      </article>
      <Footer />
    </main>
  );
}
